import styled from 'styled-components'
import { pxToRem } from '../../styles/utils'

export const VideoPlayerContainer = styled.div`
  flex: 0 0 100%;
  width: 100%;
  max-width: 100%;
  min-height: ${pxToRem(400)};
  height: ${pxToRem(400)};
  background: #000;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  border-radius: ${pxToRem(12)};
`

export const VideoWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: ${pxToRem(400)};
  overflow: hidden;

  video {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    min-height: ${pxToRem(400)};
    object-fit: contain;
    background: #000;
    margin: 0;
    padding: 0;
  }
`

export const VideoTitle = styled.div<{ $show: boolean }>`
  position: absolute;
  top: ${pxToRem(12)};
  left: ${pxToRem(12)};
  right: ${pxToRem(12)};
  padding: ${pxToRem(8)} ${pxToRem(12)};
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
  color: #fff;
  font-size: ${pxToRem(14)};
  font-weight: 500;
  border-radius: ${pxToRem(8)} ${pxToRem(8)} 0 0;
  z-index: 10;
  pointer-events: none;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  transition: opacity 0.3s ease;
`

export const QualityButton = styled.button`
  position: absolute;
  bottom: ${pxToRem(60)};
  right: ${pxToRem(12)};
  padding: ${pxToRem(8)} ${pxToRem(12)};
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: ${pxToRem(4)};
  font-size: ${pxToRem(12)};
  font-weight: 500;
  cursor: pointer;
  z-index: 15;
  transition: background 0.2s ease;
  min-width: ${pxToRem(60)};

  &:hover {
    background: rgba(0, 0, 0, 0.9);
    border-color: rgba(255, 255, 255, 0.5);
  }

  &:active {
    background: rgba(0, 0, 0, 1);
  }
`

export const QualityMenu = styled.div`
  position: absolute;
  bottom: 100%;
  right: 0;
  margin-bottom: ${pxToRem(4)};
  background: rgba(0, 0, 0, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: ${pxToRem(4)};
  min-width: ${pxToRem(100)};
  overflow: hidden;
  box-shadow: 0 ${pxToRem(4)} ${pxToRem(12)} rgba(0, 0, 0, 0.5);
`

export const QualityMenuItem = styled.div<{ $active: boolean }>`
  padding: ${pxToRem(8)} ${pxToRem(16)};
  color: #fff;
  font-size: ${pxToRem(12)};
  cursor: pointer;
  background: ${({ $active }) => ($active ? 'rgba(255, 255, 255, 0.2)' : 'transparent')};
  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }

  &:not(:last-child) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
`
